import { CampaignFormContextProvider } from './campaignForm.context';
import CampaignFormContainer from './components/campaignFormContainer/campaignFormContainer';

const CampaignForm = () => {
  return (
    <CampaignFormContextProvider>
      <CampaignFormContainer />
    </CampaignFormContextProvider>
  );
};

export default CampaignForm;
